function beatDivisionToTime(tempo, beatDivisionNumber) {
    return (60.0 / tempo) * 0.25 * beatDivisionNumber;
}

const DEBUGGING_ENABLED = false;
const TAIL_LENGTH = 16;

export function audioFile(audioContext, fileDirectory, masterGainNode, volume = 1) {
    let stopIsScheduled = false;
    let startTime = -1;

    const soundObj = {
        fileDirectory,
        bufferSource: null,
        bufferSource2: null,
        secondBufferIsPlaying: false
    };

    // Create gain node
    const gainNode = audioContext.createGain();
    gainNode.gain.value = volume;
    gainNode.connect(masterGainNode);

    fetch(soundObj.fileDirectory + (DEBUGGING_ENABLED ? '?cache=' + Date.now() : ''))
        .then((response) => response.arrayBuffer())
        .then((arrayBuffer) => {
            return new Promise((resolve, reject) => {
                audioContext.decodeAudioData(arrayBuffer, (audioBuffer) => {
                    window.dispatchEvent(new CustomEvent('soundsLoaded', { detail: true }));
                    soundObj.soundToPlay = audioBuffer;
                    resolve(audioBuffer);
                }, (error) => {
                    reject(error);
                });
            });
        })
        .catch((error) => {
            console.error('Loading audio failed', error);
        });



    soundObj.play = function (time, offset, stopTime = null) {
        if (this.bufferSource) {
            // Falls Playback beendet wurde und bevor der buffer gestoppt wird, erneut gestartet wurden, diesen Stop nicht �berschreiben
            if (!stopIsScheduled) {
                DEBUGGING_ENABLED && console.log('stop..............');
                this.bufferSource.stop(time + beatDivisionToTime(120, TAIL_LENGTH));
            }
        }
        stopIsScheduled = false;
        this.bufferSource = audioContext.createBufferSource();
        this.bufferSource.buffer = soundObj.soundToPlay;
        this.bufferSource.connect(gainNode);
        this.bufferSource.start(time, offset);

        const secondsUntilPlayback = time - audioContext.currentTime;
        DEBUGGING_ENABLED && console.log('start scheduled for in ' + secondsUntilPlayback + ' seconds.');

        this.bufferSource.onended = function () {
            this.disconnect();
        };

        startTime = time;
        this.secondBufferIsPlaying = false;

        if (!isNaN(stopTime)) {
            this.stop(stopTime);
        }
    };

    soundObj.stop = function (time) {
        // Safari throws "the object is in an invalid state" in several cases when calling stop
        try {
            if (this.secondBufferIsPlaying) {
                if (!this.bufferSource2) return;
                DEBUGGING_ENABLED && console.log('audioFile: stop buffer2');
                this.bufferSource2.stop(time);
            } else {
                if (!this.bufferSource) return;
                DEBUGGING_ENABLED && console.log('audioFile: stop buffer1');
                this.bufferSource.stop(time);
            }
        } catch (e) {}

        stopIsScheduled = true;
    };

    soundObj.seekToTime = function (startTime, playOffset, stopTime) {
        if (this.secondBufferIsPlaying && this.bufferSource2) {
            this.bufferSource2.stop();
            this.bufferSource2.disconnect();
        }

        // Schedule stop time for first buffer
        this.bufferSource.stop(startTime);

        // Play second buffer
        this.bufferSource2 = audioContext.createBufferSource();
        this.bufferSource2.buffer = this.soundToPlay;
        this.bufferSource2.connect(gainNode);
        this.bufferSource2.start(startTime, playOffset);

        this.bufferSource2.onended = function () {
            this.disconnect();
        };

        // Schedule stop time
        this.bufferSource2.stop(stopTime);

        this.secondBufferIsPlaying = true;
        DEBUGGING_ENABLED && console.log('audioFile: second buffer is playing');
    };

    return soundObj;
}
